import { useMemo, useState } from 'react'

import { useMemoizedFn } from 'src/hook/base/useMemoizedFn'
import { useRequest } from 'src/hook/base/useRequest'
import { useUpdateEffect } from 'src/hook/base/useUpdateEffect'
import { useRouter } from 'src/hook/biz/useRouter'
import { useAppUserInfoStore } from 'src/store/app/appUserInfo'
import { useUserInfoStore } from 'src/store/userInfo'
import { checkIsApp } from 'src/util/app/checkIsApp'

import { ServiceWithProps } from './type/service'
import { getServices, servicePathValid } from './utils/services'

export const GlobalModal = () => {
  const router = useRouter()

  const [service, setService] = useState<ServiceWithProps | null>(null)

  const { userInfo } = useUserInfoStore()

  const { appUserInfo } = useAppUserInfoStore()

  const { data, run, cancel } = useRequest(getServices, {
    manual: true,
    onSuccess: (services) => {
      if (!services?.length) {
        return
      }

      setService(services[0])
    }
  })

  // App环境 用户信息未初始化完成
  // Web环境 用户信息未初始化完成
  // App 环境 accessH5为FALSE
  const userInValid = useMemo(() => {
    const isApp = checkIsApp()

    return (isApp && !appUserInfo) || (!isApp && !userInfo) || (isApp && !appUserInfo?.accessH5)
  }, [userInfo, appUserInfo])

  const init = useMemoizedFn(() => {
    if (userInValid) {
      return
    }

    cancel()

    run(router.pathname)
  })

  const onFinish = useMemoizedFn(() => {
    if (!data || !service) {
      return setService(null)
    }

    const index = data?.findIndex((item) => {
      return item.service.key === service.service.key
    })

    if (index === -1) {
      return setService(null)
    }

    const nextService = data[index + 1]

    if (!nextService || !nextService.service.continue) {
      return setService(null)
    }

    setService(nextService)
  })

  // 避免data没有改变的时候多次调用render
  const memoComponent = useMemo(() => {
    if (!service) {
      return null
    }

    return service.service.render({
      ...service.props.props,
      onFinish
    })
  }, [service, onFinish])

  useUpdateEffect(init, [init, userInValid, router.pathname])

  if (!service || !servicePathValid(service.service.path, router.pathname)) {
    return null
  }

  return memoComponent
}
